import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginGuard } from '../login/login.guard';
import {CustomerComponent} from './customer.component';
import {CustomerDetailComponent} from '../customer-detail/customer-detail.component';

const routes: Routes = [
  {
    path: 'customer',
    component: CustomerComponent,
    canActivate : [LoginGuard]
  },
  {
    path: 'customer/new',
    component: CustomerDetailComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'customer/:id',
    component: CustomerDetailComponent,
    canActivate: [LoginGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerRoutingModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/customer/customer-routing.module.ts